export default {
    jira_summary_name: 'Miembro del equipo',
    jira_summary_country: 'País',
    jira_summary_days_period: 'Días en el Período',
    jira_summary_task_period: 'Tareas Cerradas',
    jira_summary_task_period_gsd: 'Tareas Cerradas GSD',
    jira_summary_task_period_others: 'Otras Tareas Cerradas',
    jira_summary_total_time_hours: 'Total en Progreso',
    jira_summary_total_time_hours_gsd: 'Total en Progreso GSD',
    jira_summary_total_time_hours_others: 'Total en Progreso Otras',
    jira_summary_total_story_points: 'Puntos de Historia Totales',
    jira_summary_total_story_points_gsd: 'Puntos de Historia Totales GSD',
    jira_summary_total_story_points_others: 'Puntos de Historia Totales Otras',
    jira_summary_total_rejected_tasks: 'Total Tareas Rechazadas',
    jira_summary_total_rejections: 'Rechazos',
    jira_summary_qa_score: 'Puntuación de QA',
    jira_summary_estimation: 'Puntuación de Estimación',
    jira_summary_participation: 'Puntaje de Participación',
    jira_summary_total: 'Puntaje Final',
    jira_summary_apply_filters: 'Aplicar los Filtros',
    jira_summary_jira_summary: 'Resumen de Jira',
    jira_summary_time_frame: 'Periodo de Tiempo',
    jira_summary_apply: 'Aplicar',
    jira_summary_bugs_responsible: 'Reponsable de Errores',
    jira_summary_total_in_progress_bugs: 'Total Errores en Progreso',
    jira_summary_total_story_points_bugs: 'Puntos de Historia de Errores Totales',
    jira_summary_closed_tags_bugs: 'Tareas Cerradas de Errores'
};
